import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Chip from "@material-ui/core/Chip";
import HTTPClient from "../../HTTPClient";
import VotedDistributed from "./VotedDistributed";
import CardHeader from "@material-ui/core/CardHeader";
import OptionsDistributed from "./OptionsDistributed";
import Loading from "../Loading";
import Clock from "../Clock";
import OptionsSingle from "./OptionsSingle";
import VotedSingle from "./VotedSingle";
import QuestionForbidden from "./QuestionForbidden";
import Button from "@material-ui/core/Button";
import config from "../../config.json";
import Box from "@material-ui/core/Box";
import {getMessage} from "../../util";

const useStyles = makeStyles(theme => ({
        paper: {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
        },
        number: {
            fontFamily: "monospace"
        },
        voted: {
            marginTop: theme.spacing(4),
        },
        paragraph: {
            margin: theme.spacing(2)
        },
        cardGrid: {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
        },
        card: {
            marginTop: theme.spacing(4),
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        cardActions: {
            justifyContent: 'center',
        },
        cardContent: {
            flexGrow: 1,
        },
        larger: {
            "font-size":"1rem"
        },
        option: {
            margin: theme.spacing(3),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',

        },
        label: {
            alignItems: 'left',
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: '25ch',
        },

    }
));


const sep = (() => {
    const n = 1.1;
    return(n.toLocaleString(navigator.language).substring(1, 2));
})();

const QuestionOpen = (props) => {


    const classes = useStyles();

    const [loading, setLoading] = useState(true);
    const [representative, setRepresentative] = useState(null);
    const [meeting_id] = useState(props.meeting.slug);

    const answers = representative ? representative.answers[props.question.slug] : null

    const question_shares = Object.keys(props.question.blanks)
    const representative_question = Object.keys(props.user.shares).filter((x) => {
        if (question_shares.indexOf(x) === -1)
            return false;
        else
            return true;
    });

    const loadData = () => {
        setLoading(true);
        HTTPClient({
            method: "get",
            url:
                process.env.REACT_APP_API_URL +
                "/meetings/" + meeting_id + "/me"
        })
            .then(response => {
                    setLoading(false);
                    setRepresentative(response.data);
                }
            )
            .catch((error) => {
                setLoading(false);

            });

    }

    useEffect(() => {
        setLoading(true);
        HTTPClient({
            method: "get",
            url:
                process.env.REACT_APP_API_URL +
                "/meetings/" + meeting_id + "/me"
        })
            .then(response => {
                    setLoading(false);
                    setRepresentative(response.data);
                }
            )
            .catch((error) => {
                setLoading(false);

            });

    }, [meeting_id]);


    const represented = Object.keys(props.question.blanks).map(k => {
        return (props.meeting.shares[k].rights * props.meeting.shares[k].represented);
    }).reduce((acc, elem) => {
        return (acc + elem);
    }, 0);
    const turnout = Object.keys(props.question.turnout).map(k => {
        return (props.meeting.shares[k].rights * props.question.turnout[k].shares);
    }).reduce((acc, elem) => {
        return (acc + elem);
    }, 0);


    const distributed = (
        (representative && representative.custodian) ||
        props.question.distributed)

    const percentage_voted = represented ? (100 * turnout / represented) : 0;
    const percentage_voted_k = Object.keys(props.question.blanks).reduce((acc, k) => {
        acc[k] = props.meeting.shares[k].represented ? (100 * props.question.turnout[k].shares / props.meeting.shares[k].represented) : 0;
        return (acc);
    }, {});

    let nines = "99".concat(sep);
    for (let i = 0; i < config.precision; i++) {
        nines = nines.concat("9")
    }
    nines = nines.concat("...")

    return (
        <Container>
            <Box mb={2}>
                <Typography variant={"h5"}>
                    {getMessage(props.meeting.meeting_type,'voting_in_process',props.messages)} {props.user.observer && <Button variant="contained" color={"default"}
                                                                        href={"/meeting/question/" + props.question.slug + "/answers"}>
                    {getMessage(props.meeting.meeting_type,'watch_voting_detail',props.messages)}</Button>}
                </Typography>
            </Box>

            <Grid container spacing={1}>
                <Grid item xs={4} className={classes.state}>
                    <Typography align={"center"}>
                        {getMessage(props.meeting.meeting_type,'turnout',props.messages)}
                    </Typography>
                    <span className={classes.larger}>{getMessage(props.meeting.meeting_type,'total',props.messages)}: <span
                        className={classes.number}>{(percentage_voted > (100-1/Math.pow(10,config.precision)) && percentage_voted < 100) ? nines : percentage_voted.toLocaleString(navigator.language, {
                        maximumFractionDigits: config.precision, minimumFractionDigits: 2
                    })}% {turnout.toLocaleString(navigator.language, {
                        maximumFractionDigits: config.precision
                    })} </span> <br/>
                        {(props.meeting.shares[Object.keys(props.meeting.shares)[0]].rights !== 1 || Object.keys(props.meeting.shares).length > 1)  && Object.keys(props.question.blanks).map(k => (
                            <span key={k}>
                                    {props.meeting.shares[k].name}: <span
                                className={classes.number}>{(percentage_voted_k[k] > (100-1/Math.pow(10,config.precision)) && percentage_voted_k[k] < 100) ? nines : percentage_voted_k[k].toLocaleString(navigator.language, {
                                maximumFractionDigits: config.precision, minimumFractionDigits: 2
                            })}%, {props.question.turnout[k].shares.toLocaleString(navigator.language, {
                                maximumFractionDigits: config.precision
                            })}</span>
                                <br/></span>
                        ))}
                            </span>
                </Grid>
                <Grid item xs={4} className={classes.state}>

                    <Typography align={"center"}>
                        {getMessage(props.meeting.meeting_type,'state',props.messages)}
                    </Typography>
                    <Typography align={"center"}>
                        <Chip component={"span"} label={getMessage(props.meeting.meeting_type,'question_open',props.messages)}/>
                    </Typography>

                </Grid>
                <Grid item xs={4} className={classes.state}>

                    <Typography align={"center"}>
                        {getMessage(props.meeting.meeting_type,'resting_time',props.messages)}
                    </Typography>
                    <Typography align={"center"}>
                        <Clock messages={props.messages} meeting={props.meeting} end_date={props.question.end_date}/>
                    </Typography>
                </Grid>
            </Grid>


            <Card variant="outlined" className={classes.card}>
                <CardHeader title={props.question.name} titleTypographyProps={{variant: 'h6'}}/>

                {loading ? (
                    <Loading/>
                ) : (representative && (
                        <CardContent className={classes.cardContent}>
                            {answers ? (distributed ? (
                                    <VotedDistributed messages={props.messages} question={props.question} answers={answers.options}
                                                      user={props.user} meeting={props.meeting}/>

                                ) : (
                                    <VotedSingle messages={props.messages} question={props.question} answers={answers.options} user={props.user}
                                                 meeting={props.meeting}/>

                                )
                            ) : (representative_question.length > 0 ? (distributed ? (
                                    <OptionsDistributed meeting={props.meeting}
                                                        messages={props.messages}
                                                        question={props.question}
                                                        user={props.user}
                                                        vote={loadData}
                                    />
                                ) : (
                                    <OptionsSingle meeting={props.meeting}
                                                   messages={props.messages}
                                                   question={props.question}
                                                   user={props.user}
                                                   vote={loadData}
                                    />
                                )) : (
                                    <QuestionForbidden meeting={props.meeting}
                                                       messages={props.messages}
                                                       question={props.question}
                                                       user={props.user}
                                    />
                                )
                            )}
                        </CardContent>
                    )
                )}


            </Card>


        </Container>
    )
}

export default QuestionOpen;